import {useDispatch} from "react-redux";
import type {Dispatch} from "redux";

import {appendAmplitudeCrossDomainParams, waitForAmplitudeInitialization} from "@pg-mono/amplitude";
import {appendQueryString, IQuery} from "@pg-mono/request";
import {apiUserLink} from "@pg-mono/rp-api-routes";
import {rpAppPath} from "@pg-mono/rp-routes";
import {clearPhoneVerificationTimerLS} from "@pg-mono/user";
import {decorateUrlWithGaLinker} from "@pg-rp/navigation";

import {kmUrl} from "../../app/read_rp_environment_variables";
import {emptyLeadStorageData} from "../../application/constants/lead/empty_lead_storage_data";
import {ISentLeadActions, setSentLeadValuesAction} from "../../application/reducers/sent_lead_reducer";
import {removeArticleAttachmentLSStore} from "../../article/hooks/use_article_attachment_ls_store";

const kmHostname = new URL(kmUrl).hostname;

export const useRedirectedAuth = () => {
    const dispatch: Dispatch<ISentLeadActions> = useDispatch();

    const onRedirectedLogin = async (redirectUriQuery: IQuery = {}) => {
        const query: IQuery = {
            redirect_uri: appendQueryString(`${location.origin}${rpAppPath.oauth.redirect}`, redirectUriQuery)
        };

        await waitForAmplitudeInitialization();
        window.location.href = appendAmplitudeCrossDomainParams(decorateUrlWithGaLinker(appendQueryString(apiUserLink.oauth.authorize, query)), [kmHostname]);
    };

    const onRedirectedLogout = () => {
        removeArticleAttachmentLSStore();
        clearPhoneVerificationTimerLS();
        dispatch<ISentLeadActions>(setSentLeadValuesAction(emptyLeadStorageData));
        window.location.href = appendQueryString(apiUserLink.users.logout, {
            next: `${location.origin}${location.pathname}`
        });
    };

    return {
        onRedirectedLogin,
        onRedirectedLogout
    };
};
import {useDispatch} from "react-redux";
import type {Dispatch} from "redux";

import {appendAmplitudeCrossDomainParams, waitForAmplitudeInitialization} from "@pg-mono/amplitude";
import {appendQueryString, IQuery} from "@pg-mono/request";
import {apiUserLink} from "@pg-mono/rp-api-routes";
import {rpAppPath} from "@pg-mono/rp-routes";
import {clearPhoneVerificationTimerLS} from "@pg-mono/user";
import {decorateUrlWithGaLinker} from "@pg-rp/navigation";

import {kmUrl} from "../../app/read_rp_environment_variables";
import {emptyLeadStorageData} from "../../application/constants/lead/empty_lead_storage_data";
import {ISentLeadActions, setSentLeadValuesAction} from "../../application/reducers/sent_lead_reducer";
import {removeArticleAttachmentLSStore} from "../../article/hooks/use_article_attachment_ls_store";

const kmHostname = new URL(kmUrl).hostname;

export const useRedirectedAuth = () => {
    const dispatch: Dispatch<ISentLeadActions> = useDispatch();

    const onRedirectedLogin = async (redirectUriQuery: IQuery = {}) => {
        const query: IQuery = {
            redirect_uri: appendQueryString(`${location.origin}${rpAppPath.oauth.redirect}`, redirectUriQuery)
        };

        await waitForAmplitudeInitialization();
        window.location.href = appendAmplitudeCrossDomainParams(decorateUrlWithGaLinker(appendQueryString(apiUserLink.oauth.authorize, query)), [kmHostname]);
    };

    const onRedirectedLogout = () => {
        removeArticleAttachmentLSStore();
        clearPhoneVerificationTimerLS();
        dispatch<ISentLeadActions>(setSentLeadValuesAction(emptyLeadStorageData));
        window.location.href = appendQueryString(apiUserLink.users.logout, {
            next: `${location.origin}${location.pathname}`
        });
    };

    return {
        onRedirectedLogin,
        onRedirectedLogout
    };
};
